import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import { NavLink } from "react-router-dom";
import { Query } from "react-apollo";
import gql from "graphql-tag";

import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import Button from "../../components/CustomButton/CustomButton.jsx";
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; //

const restLink_payMethod = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'
 });
const payMethod_client = new ApolloClient({
  link: restLink_payMethod,
  cache: new InMemoryCache(),
});

function getUrl($param, $param_1 = null,$param_2 = null) {
  var $url = "/#/"+$param;
  if($param_1 != null) {
    $url += "/"+$param_1;
  }
  if($param_2 != null) {
    $url += "/"+$param_2;
  }
  return $url;
}

const GET_PAYMETHOD = gql`
  query getPayMethods($search: String!, $limit: Int!, $page: Int!, $order: String!, $orderby: String!){
    payMethod_collection(search: $search, limit: $limit, page: $page, order: $order, orderby: $orderby){
      payMethods{
        id
        type
        boleto{
          id
          boleto_url
          amountTotal
        }
      }
    }
  }
`;

const COUNT_PAYMETHODS = gql`query countPayMethods($search: String!){
  payMethod_count(search:$search){
    count
  }
}
`;

const DELETE_PAYMETHOD = gql`
  mutation deletePayMethod($id: Int!){
    deletePayMethod(id:$id) {
      id
    }
  }
`;


class PayMethodList extends Component {

  state = {
    search: '',
    limit: 20,
    page: 1,
    orderby: "id",
    order: "DESC"
  }

  toggleOrder = (event) => {
    this.setState({
      order: (this.state.order == 'DESC'? 'ASC' : 'DESC')
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState({
      search: event.target.elements.search.value,
      order: event.target.elements.order.value,
      orderby: event.target.elements.orderby.value
    });

  }

  render() {
    
    return (

      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <NavLink
                  to={'/payment-methods-new/'}
                  className="btn btn-info btn-fill"
                  activeClassName=""
                >
                Novo Meio de Pagamento 
              </NavLink>
              <Card
                title={"Meios de Pagamento"}
                payMethod="Gerenciar Meios de Pagamento"
                ctTableFullWidth
                ctTableResponsive
                content={

                  <Table striped hover>
                    <thead>
                      <tr>
                      <th colSpan={9}>
                            <form 
                            onSubmit={e => {
                              this.handleSubmit(e);
                              e.preventDefault();
                            }}
                            >
                              <Row>
                                  <Col md={6} lg={3}>
                                      <input  type="text" name="search" className="form-control" />
                                  </Col>
                                  <Col md={2}>
                                    <Button bsStyle="info" fill type="submit" >
                                      Buscar
                                    </Button>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={6} lg={1}>
                                      <select name="orderby" className="form-control">
                                        <option value="id">ID</option>
                                        <option value="titulo">Nome do Meio de Pagamento</option>
                                      </select>
                                  </Col>
                                  <Col md={6} lg={2}>
                                      <select name="order" className="form-control">
                                        <option value="DESC">Decrescente</option>
                                        <option value="ASC" selected={this.state.order == "ASC"}>Crescente</option>
                                      </select>
                                  </Col>
                                  <Col md={2}>
                                    <Button bsStyle="info" fill type="submit" >
                                      Ordenar
                                    </Button>
                                  </Col>
                                </Row>
                            </form>
                        </th>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Tipo</th>
                        <th>Status</th>
                        <th></th>
                        
                      </tr>
                    </thead>
                    <tbody>

                        <Query
                          client={payMethod_client}
                          query={GET_PAYMETHOD}
                          variables={{
                            search: this.state.search, 
                            limit: this.state.limit, 
                            page: this.state.page, 
                            order: this.state.order, 
                            orderby: this.state.orderby
                          }}
                          fetchPolicy='no-cache'
                        >
                          {({ loading, error, data }) => {
                            if (loading) return <tr><td>Carregando...</td></tr>;
                            if (error) return <tr><td>Erro :(</td></tr>;
                              
                              if(!data.payMethod_collection) {
                                return (<tr><td>(Vazio)</td></tr>);
                              } 
                              return data.payMethod_collection.payMethods.map((item) => (
                              
                              <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.type == "boleto" ? "Boleto Pré Pago" : "Cartão de Crédito"}</td>
                                <td>{item.type == "boleto" ? "Pagamento pendente" : "Ativo"}</td>
                                <td>{item.type == "boleto" && item.boleto != null? "R$ "+ item.boleto.amountTotal : ""}</td>
                                <td>{item.type == "boleto" && item.boleto != null ? <a href={item.boleto.boleto_url} target="_blank">Abrir boleto</a> : ""}</td>

                                
                              </tr>
                            ));
                          }}
                        </Query>
                        <Query
                          client={payMethod_client}
                          query={COUNT_PAYMETHODS}
                          variables={{
                            search: this.state.search
                          }}
                          fetchPolicy='no-cache'
                        >
                          {({ loading, error, data }) => {
                            if (loading) return <tr><td>Carregando...</td></tr>;
                            if (error) return <tr><td>Erro :(</td></tr>;

                              var pagination_buttons = [];
                              var total_pages = data.payMethod_count.count/this.state.limit;
                              for(var page_num = 1; Math.ceil(total_pages) >= page_num; page_num++){
                                pagination_buttons.push(<spam><spam page_num={page_num} className={"btn_page "+(this.state.page==page_num ? 'btn_page_active' : '')} onClick={e => {this.setState({page: e.target.getAttribute('page_num')})}} >{page_num}</spam> </spam>);
                              }
                            return (
                              <tr key={1}>
                                <td colSpan={6}>
                                  {pagination_buttons}
                                </td>
                              </tr>
                            );
                          }}
                        </Query>
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default PayMethodList;
